import React from 'react';
import { Switch, Route } from 'react-router-dom';
import BulletinCompositionList from './bulletin-composition-list';
import BulletinCompositionForm from './bulletin-composition-form';
import { paths } from '../../../routes';

const BulletinComposition = () => (
    <Switch>
        <Route path={paths.newBulletinComposition.path}>
            <BulletinCompositionForm />
        </Route>
        <Route path={paths.bulletincomposition.path + '/:reportId'}>
            <BulletinCompositionForm />
        </Route>
        <Route path={paths.bulletincomposition.path}>
            <BulletinCompositionList />
        </Route>
    </Switch>
);

export default BulletinComposition;
